export default __webpack_public_path__ + "static/media/plusDarkBlue.71ee2084.svg";